import React, { useEffect } from "react";
import { FormField } from "./FormField";
import styles from "./styles.module.scss";
import { useFormStore } from "src/store/dataEntryForm";
import { Select } from "antd";

interface SearchQueryProductFormProps {
  formId: string;
}

const productOptions = [
  { value: "product1", label: "Premium iPhone Case - White" },
  { value: "product2", label: "Premium iPhone Case - Black" },
  { value: "product3", label: "Waterproof Phone Case - Universal" },
  { value: "product4", label: "Leather Wallet Case - iPhone 14" },
  { value: "product5", label: "Slim Protective Case - Samsung Galaxy" },
];

const keywordOptions = [
  { value: "iphone_case", label: "iPhone Case" },
  { value: "waterproof_case", label: "Waterproof Case" },
  { value: "protective_case", label: "Protective Case" },
  { value: "slim_case", label: "Slim Case" },
  { value: "leather_wallet", label: "Leather Wallet Case" },
];

export const SearchQueryProductForm: React.FC<SearchQueryProductFormProps> = ({
  formId,
}) => {
  const { initializeForm, resetForm, updateFormField, formData } =
    useFormStore();

  const handleProductChange = (value: string) => {
    updateFormField(formId, "product", value);
  };

  const handleKeywordChange = (value: string[]) => {
    updateFormField(formId, "keyword", value);
  };

  useEffect(() => {
    initializeForm(formId, {
      product: "",
      keyword: [],
      keywordSalesAttribution: "",
      lostImpressionShare: "",
      buyBoxWinRate: "",
    });

    return () => resetForm(formId);
  }, [formId, initializeForm, resetForm]);

  const productValue = formData[formId]?.product ?? "";
  const keywordValue = formData[formId]?.keyword ?? [];

  return (
    <div className={styles.addSkuContainer}>
      {/* Product */}
      <div className={styles.row}>
        <div className={styles.fullWidthSelect}>
          <label htmlFor="asin-select" className={styles.fieldLabel}>
            Product
          </label>
          <Select
            id="asin-select"
            placeholder="Select product"
            value={productValue ?? undefined}
            onChange={handleProductChange}
            options={productOptions}
            className={styles.fullWidthSelect}
            allowClear
            showSearch
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            popupClassName="custom-select-dropdown"
          />
        </div>
      </div>

      {/* Top Ranking Keywords */}
      <div className={styles.row}>
        <div className={styles.fullWidthSelect}>
          <label htmlFor="asin-select-ranking" className={styles.fieldLabel}>
            Top Ranking Keywords
          </label>
          <Select
            id="asin-select-ranking"
            mode="multiple"
            placeholder="Select top ranking keywords"
            value={keywordValue}
            onChange={handleKeywordChange}
            options={keywordOptions}
            className={styles.fullWidthSelect}
            allowClear
            maxTagCount="responsive"
            showSearch
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            popupClassName="custom-select-dropdown"
          />
        </div>
      </div>

      {/* Other Fields */}
      <div className={styles.row}>
        <FormField
          formId={formId}
          fieldName="keywordSalesAttribution"
          label="Keyword Sales Attribution, %"
          placeholder=""
          type="number"
          size="small"
        />
        <FormField
          formId={formId}
          fieldName="lostImpressionShare"
          label="Lost Impression Share, %"
          placeholder=""
          type="number"
          size="small"
        />
      </div>

      <div className={styles.row}>
        <FormField
          formId={formId}
          fieldName="buyBoxWinRate"
          label="Buy Box Win Rate from Search, %"
          placeholder=""
          type="number"
          size="small"
        />
      </div>
    </div>
  );
};
